export default __webpack_public_path__ + "static/media/upcoming-collection--collection-1.50a49eb6.png";